import {trackEvent} from '~/utils/posthog';

export default defineNuxtPlugin(nuxtApp => {
  const toast = useToast();
  const isLoadingModalOpen = useState('isLoadingModalOpen', () => false);

  const upgrade = async (targetPlan, toastOptions) => {
    trackEvent('upgrade_prompt_shown', {
      target_plan: targetPlan,
      source: toastOptions?.title || 'general_upgrade',
      has_toast_message: !!toastOptions,
    });

    isLoadingModalOpen.value = true;
    await navigateTo(`/billing?plan=${targetPlan}`);
    isLoadingModalOpen.value = false;
    if (toastOptions) {
      setTimeout(() => {
        toast.add({
          title: toastOptions.title,
          description: toastOptions.description,
        });
      }, 2000);
    }
  };

  return {
    provide: {
      upgrade,
    },
  };
});
